<template>
  <form data-vv-scope="batchJobForm">
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-clock</v-icon>
        <v-toolbar-title>Schedule Job {{ this.jobName }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-autocomplete
                :items="runningType"
                v-model="batchForm.runningType"
                item-text="label"
                item-value="value"
                data-vv-name="batchForm.runningType"
                :data-vv-as="label.runningType"
                :error-messages="errors.collect('batchForm.runningType')"
                @change="manageDateTime"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="showJobMode">
              <v-autocomplete
                :items="jobModes"
                v-model="batchForm.jobMode"
                :label="label.jobMode"
                item-text="label"
                item-value="value"
                data-vv-name="batchForm.jobMode"
                :data-vv-as="label.jobMode"
                :error-messages="errors.collect('batchForm.jobMode')"
                v-validate="'required'"
                clearable
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="batchForm.jobMode === 'ONCE'">
              <cal-picker
                v-model="batchForm.jobSchedule"
                :label="label.jobSchedule"
                :error-messages="errors.collect('batchForm.jobSchedule')"
                :data-vv-as="label.jobSchedule"
                v-validate="this.batchForm.runningType === 'S' ? 'required' : ''"
                data-vv-name="batchForm.jobSchedule"
                :disabled="this.hideDateTime"
              ></cal-picker>
            </v-flex>
            <v-flex xs12 v-if="this.hideDateTime === false">
              <v-dialog ref="dialog" v-model="timeModal" :return-value.sync="batchForm.jobScheduleTime" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    prepend-icon="mdi-clock"
                    v-model="batchForm.jobScheduleTime"
                    :data-vv-as="label.jobScheduleTime"
                    data-vv-name="batchForm.jobScheduleTime"
                    :error-messages="errors.collect('batchForm.jobScheduleTime')"
                    :label="label.jobScheduleTime"
                    v-validate="batchForm.runningType === 'S' ? 'required' : ''"
                    readonly
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-time-picker v-if="timeModal" v-model="batchForm.jobScheduleTime">
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="timeModal = false">Cancel</v-btn>
                  <v-btn color="primary" text @click="$refs.dialog.save(batchForm.jobScheduleTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex md12 xs12>
              <v-textarea
                prepend-icon="mdi-pencil"
                v-model="batchForm.jobDesc"
                :label="label.jobDesc"
                no-resize
                rows="3"
                :error-messages="errors.collect('batchForm.jobDesc')"
                data-vv-name="jobDesc"
                :data-vv-as="label.jobDesc"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="doExit">Cancel</v-btn>
        <v-btn color="primary" @click="doSubmitJob">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'
import clone from 'clone'
export default {
  data() {
    return {
      label: {
        schedule: 'Schedule',
        jobName: 'Job Name',
        jobCron: 'Job Cron Expression',
        jobSchedule: 'Schedule Date',
        jobMode: 'Frequency',
        jobScheduleTime: 'Schedule Time',
        jobDesc: 'Job Description',
        runningType: 'Running Type'
      },
      jobModes: [{ label: 'Run Once', value: 'ONCE' }],
      jobWarningMessage: '',
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      selectedDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      showAddSchedule: false,
      timeModal: false,
      hideDateTime: true
    }
  },
  methods: {
    doSubmitJob() {
      this.resetMessages()
      this.$validator.validateAll('batchJobForm').then(result => {
        if (result) {
          this.doPopulate()
          this.doExit()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    initSchedule() {
      this.$parent.$parent.$validator.validateAll().then(result => {
        if (result) {
          this.showAddSchedule = true
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPopulate() {
      let bmgForms = clone(this.batchForm)
      bmgForms.jobKeys = this.jobKeys
      bmgForms.skipValidate = this.skipValidate
      this.$emit('doPopulate', bmgForms)
    },
    doExit() {
      this.$emit('close')
    },
    manageDateTime() {
      if (this.batchForm.runningType === 'I') {
        this.hideDateTime = true
        this.batchForm.jobSchedule = ''
        this.batchForm.jobScheduleTime = ''
      } else {
        this.hideDateTime = false
        this.batchForm.jobSchedule = new Date()
      }
    }
  },
  computed: {
    jobName() {
      if (this.scheduleForm != null) {
        return ' - ' + this.scheduleForm.jobDesc
      } else {
        return ''
      }
    }
  },
  watch: {},
  props: {
    jobKeys: {
      type: Object,
      default: null
    },
    showJobMode: {
      type: Boolean,
      default: true
    },
    scheduleForm: {
      type: Object,
      default: null
    },
    skipValidate: {
      type: Boolean,
      default: false
    }
  },
  mixins: [MessageMixin, batchManagerMixin]
}
</script>
